module.exports = __webpack_public_path__ + "static/media/mission-makeeasy-ic.d7fc48dd.svg";